module.exports = __webpack_public_path__ + "img/Stat_fire_arms.56526590.png";